var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button-control"},[_c('div',{staticClass:"switch-button",class:{ enabled: _vm.value, disabled: !_vm.value, frozen: _vm.frozen },on:{"click":_vm.onToggle}},[_c('div',{staticClass:"button",class:{ tableCompatible: _vm.tableCompatible }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }